<template>
  <div>

    <Prompt v-if="isPopDialogShown" :is-shown.sync="isPopDialogShown">
      <template v-slot:content>
        <div class="title title-style">温馨提示</div>
        <p class="description">
          {{popDialogMsg}}
        </p>
      </template>
    </Prompt>

    <toast :toast-msg="toastMsg"></toast>

    <FollowDialog v-if="isFollowDialogShown" :is-shown.sync="isFollowDialogShown"></FollowDialog>

    <Prompt v-if="isDismissTeamShown" :is-shown.sync="isDismissTeamShown" :doubleBtn="true">
      <template v-slot:content>
        <div class="title">温馨提示</div>
        <p class="description">您确定要解散，失去解锁史诗皮肤和专属头像框的机会吗？</p>
      </template>
      <template v-slot:button>
          <div class="tips-btn-t" @click="dismiss">狠心解散</div>
          <div class="tips-btn-b" @click="showDismissTeamDialog(false)">取消</div>
      </template>
    </Prompt>
    <Prompt v-if="isQuitDialogShown" :is-shown.sync="isQuitDialogShown" :doubleBtn="true">
      <template v-slot:content>
        <div class="title">温馨提示</div>
        <p class="description">您确定要退出<span v-if="!userAgent.weixin">小队</span>吗？</p>
      </template>
      <template v-slot:button>
        <div class="tips-btn-t" @click="quit">确定</div>
        <div @click="setQuitDialog(false)" class="tips-btn-b">取消</div>
      </template>
    </Prompt>
    <div class="content2">
      <!--战队组建及申请-->
      <!-- 组队期我的战队【队长】 -->
      <div class="index-application" :class="{'index-application':selectedTeamTab==teamTab.MY_TEAM,'index-application-r':selectedTeamTab==teamTab.APPROVAL}" v-if="isCaptain===true && period==peroidEnums.FORMATION">
        <div class="tab">
          <div class="tab-l" @click="changeTeamTab(teamTab.MY_TEAM)">
            我的小队 <span>{{teamInfo.join.length}}</span>/<span>{{teamInfo.max_join_quantity}}</span>
          </div>
          <div class="tab-r" @click="changeTeamTab(teamTab.APPROVAL)">
            入队申请
            <span v-if="applicantList.length>0">New</span>
          </div>
        </div>
        <!-- 我的战队 -->
        <div class="cont" v-show="selectedTeamTab==teamTab.MY_TEAM">
          <div class="my-bar"></div>
          <!-- 牛头灯 -->
          <div class="light"></div>
          <TeamMembers 
            :captain="captain" 
            :now="now" 
            :team-members="teamMembers" 
            :default-avatar="gameInfo.defaultAvatar"
            default-nickname="腾讯用户"
          >
          </TeamMembers>
          <!-- 审核 -->
          <div class="review">
            <div class="review-l">
              <label class="txms-mod-switch txms-mod-switch--active" @click="setApprovalStatus">
                <div class="txms-mod-switch__target">
                  <input aria-labelledby="l1" class="txms-switch" type="checkbox" v-model="isTeamNeedApproval">
                </div>
              </label>
              入队需通过审核
            </div>
            <p class="review-r" v-if="teamMembers.length==0" @click="showDismissTeamDialog(true)">解散小队</p>
          </div>
        </div>
        <!-- 战队申请 -->
        <div class="cont-r" v-show="selectedTeamTab==teamTab.APPROVAL">
          <div class="my-bar"></div>
          <!-- 牛头灯 -->
          <div class="light"></div>
          <div class="join-con-scroll" v-if="applicantList.length>0">
            <div class="join-con-item" v-for="u in applicantList" :key="u.uin" >
              <img :src="getMember(u.nick_img).avatar" alt="" />
              <div class="info">
                <p>{{ getMember(u.nick_img).nickName }}</p>
              </div>
              <div class="btns">
                <div class="btn btn-l" @click="approval(u,'refuse')">忽略</div>
                <div class="btn" @click="approval(u,'agree')">通过</div>
              </div>

            </div>
            <div class="refresh-m" @click="getApplyMembers" v-if="!applicantFetchFinished">
              <img  :class="[isApplicationRefreshing? 'spin-style' : '']" src="~2021team-pk-ui/assets/refresh.png" alt="">加载更多
            </div>
          </div>
          <div class="join-con-scroll" v-else>
            <div class="join-con-item join-con-item--style">
              <div class="info">
                <p>
                  暂无申请
                </p>
              </div>
            </div>
          </div>
          <div class="tips" @click="showFollowDialog">
            订阅审批提醒
          </div>

        </div>
      </div>


      <!-- 组队期我的战队【队员】 -->
      <div class="index-team-my" v-if="isCaptain===false && period==peroidEnums.FORMATION" >
        <div class="my-title">
          {{ isInTeam ? "我的小队" : "小队成员" }}
          <span>{{teamInfo.join.length}}</span>/<span>{{teamInfo.max_join_quantity}}</span>
        </div>
        <div class="my-bar"></div>
        <div class="team-tips">&nbsp;</div>
        <TeamMembers 
          :captain="captain" 
          :now="now" 
          :team-members="teamMembers" 
          :default-avatar="gameInfo.defaultAvatar"
          default-nickname="腾讯用户"
          className="con-scroll-style"
        >
        </TeamMembers>
        <p class="abort" @click="setQuitDialog(true)" v-if="isInTeam && quitTeamEndTime * 1000 > now">
          退出小队(倒计时:
          <CountDown :end-time="quitTeamEndTime" style="text-decoration: underline"></CountDown>)
        </p>
      </div>

      <!-- 蓄水结束准备期（组队期和消费期中间的时间） -->
      <div class="index-team-my" v-if="period==peroidEnums.PREPARE && (isCaptain || isInTeam)" >
        <div class="my-title">
          {{ isInTeam ? "我的小队" : "小队成员" }}
          <span>{{teamInfo.join.length}}</span>/<span>{{teamInfo.max_join_quantity}}</span>
        </div>
        <div class="my-bar"></div>
        <div class="team-tips" v-if="teamMembers.length==0">
          很遗憾，没有队员加入小队已自动解散
        </div>
        <!-- 暂不支持QQ拉群 -->
        <!-- <div class="team-tips" v-else-if="teamInfo.origin_type=='qq'">战队组队成功后，可由队长一健创建QQ群</div> -->
        <TeamMembers 
          :captain="captain" 
          :now="now" 
          :team-members="teamMembers" 
          :default-avatar="gameInfo.defaultAvatar"
          default-nickname="腾讯用户"
          className="con-scroll-style"
        >
        </TeamMembers>
      </div>

      <!-- 领奖期 -->
      <div class="index-create index-create-ash" v-if="period == peroidEnums.PK && periodBeforeConversionTime === false" >
        <p>活动结束 敬请期待下期</p>
      </div>

      <!--消费期战队贡献-->
      <div class="index list" v-if="period==peroidEnums.PK && (isInTeam || isCaptain) && teamMembers.length>0">
        <div class="caption">
          <img class="caption-l" src="~2021team-pk-ui/assets/index-title-icon-l.png" alt="">
          小队贡献榜
          <img class="caption-r" src="~2021team-pk-ui/assets/index-title-icon-r.png" alt="">
        </div>
        <div class="list-con">
          <div class="list-con-title">
            <p>小队累计：<span>{{totalConsumption}}{{currencyName}}</span></p>
            <p>我的贡献：<span>{{selfConsumption}}{{currencyName}}</span></p>
            <p>*活动数据统计每2分钟更新一次 本次刷新时间：{{formatDate(now,"HH:mm:ss")}}</p>
          </div>
          <div class="list-content">
            <!-- 123 -->
            <div class="list-content-top" >
              <div class="list-content-top-item" v-if="teamConsumption && teamConsumption[1]">
                <div class="img img-2" >
                  <img :src="getMember(teamConsumption[1].nick_img).avatar" />
                </div>
                <p class="name">{{getMember(teamConsumption[1].nick_img).nickName}}</p>
                <span class="coupon">{{teamConsumption[1].amt}}{{currencyName}}</span>
              </div>
              <div class="list-content-top-item" v-if="teamConsumption && teamConsumption[0]">
                <div class="img img-1 ">
                  <img :src="getMember(teamConsumption[0].nick_img).avatar" />
                </div>
                <p class="name">{{getMember(teamConsumption[0].nick_img).nickName}}</p>
                <span class="coupon">{{teamConsumption[0].amt}}{{currencyName}}</span>
              </div>
              <div class="list-content-top-item" v-if="teamConsumption && teamConsumption[2]">
                <div class="img img-3">
                  <img :src="getMember(teamConsumption[2].nick_img).avatar" />
                </div>
                <p class="name">{{getMember(teamConsumption[2].nick_img).nickName}}</p>
                <span class="coupon">{{teamConsumption[2].amt}}{{currencyName}}</span>
              </div>
            </div>
            <!-- 456 -->
            <div class="bar" v-if="teamConsumption.length>3"></div>
            <div class="list-content-bottom" v-if="teamConsumption.length>3">
              <div class="list-content-bottom-item" v-for="(c,index) in teamConsumption" :key="c.uin" v-if="index>2">
                <div class="left">
                  <span>{{index+1}}</span>
                  <div>
                    <img :src="getMember(c.nick_img).avatar" alt="" />
                  </div>
                  <p >{{getMember(c.nick_img).nickName}}</p>
                </div>
                <p class="right">{{c.amt}}{{currencyName}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

       <!-- 消费期投放消费的广告位 -->
      <div class="index index-team" v-if="period==peroidEnums.PK && periodBeforeConversionTime === true && (isInTeam || isCaptain) && teamMembers.length>0 && consumeAds.length>0">
        <div class="caption">
          <img class="caption-l" src="~2021team-pk-ui/assets/index-title-icon-l.png" alt="">
          兔限皮肤热销中
          <img class="caption-r" src="~2021team-pk-ui/assets/index-title-icon-r.png" alt="">
        </div>
        <div class="jf-skin-con">
          <div class="jf-skin-icon"></div>
          <div class="jf-skin-list">
            <img :src="item.url" @click="redirectOut(item.link)" v-for="(item,index) in consumeAds" :key="'consumeAds'+index" alt="">
          </div>
        </div>
        <!-- <p class="goods-go"> -->
          <!-- <span></span> -->
          <!-- <span @click="goMall">逛逛其他商品</span> -->
          <!-- <span @click="goPostOffice">给好友寄明信片</span> -->
        <!-- </p> -->
      </div>

      <!-- 消费期没有队伍显示组队活动结束 || 不包含领奖期是因为领奖期会显示【活动结束 敬请期待下期】-->
      <div class="team-end" v-if="period==peroidEnums.PK && periodBeforeConversionTime === true && ((!isInTeam && !isCaptain) || teamMembers.length==0)">
        <img src="~2021team-pk-ui/assets/team-end-icon.png" alt=""> 很可惜，活动组队期已结束
      </div>

      <div class="team-end" v-if="period==peroidEnums.PREPARE && !isInTeam">
        <img src="~2021team-pk-ui/assets/team-end-icon.png" alt=""> 很可惜，活动组队期已结束
      </div>

    </div>

    <div class="index-btns" v-if="isCaptain===false && period==peroidEnums.FORMATION">
      <div class="index-btns-l" v-if="!isInTeam" @click="returnIndexAndCreateTeam">返回创建自己的小队</div>
      <div class="index-btns-r" @click="join" v-if="!selfMember && !isInTeam" >申请加入（<span v-if="isTeamNeedApproval">需审批</span><span v-else>无审批</span>）</div>
      <div class="index-btns-r" @click="join" v-if="selfMember && selfMember.status==joinStatus.APPLY">提醒队长通过</div>


      <div class="index-btns-l" @click="showSubscribeDialog" v-if="isInTeam">订阅活动提醒</div>
      <div class="index-btns-r" v-if="isInTeam" @click="showTeamShareFromMember">扩散小队召集令</div>
    </div>

    <div class="index-btns" v-if="isCaptain===true && period==peroidEnums.FORMATION" >
      <div class="index-btns-l" @click="showSubscribeDialog">
        订阅活动提醒
      </div>
      <!-- 一个按钮 添加类 index-btns-r-one-bg -->
      <div class="index-btns-r" @click="showTeamShare">
        发布小队召集令
      </div>
    </div>

    <div class="index-btns" v-if="(period==peroidEnums.PREPARE || period==peroidEnums.PK) && periodBeforeConversionTime === true" >
      <!-- 一个按钮 添加类 index-btns-r-one-bg -->
      <div class="index-btns-r index-btns-r-one-bg" @click="showSubscribeDialog">
        订阅活动提醒
      </div>
    </div>

    <div class="index-btns" v-if="!teamInfo && !isInTeam && period == peroidEnums.FORMATION" >
      <div class="index-btns-r index-btns-r-one-bg" @click="returnIndexAndCreateTeam">
       返回创建自己的小队
      </div>
    </div>

    <Prompt v-if="isQueueShown" :is-shown.sync="isQueueShown" is-close-hidden="true">
      <template v-slot:content>
        <div class="title">温馨提示</div>
        <p class="description" style="text-align: center">哎呀，活动太火爆啦，正在排队进入……
          <span>{{ retryCountDown > 0 ? retryCountDown : "" }}</span>
        </p>
      </template>
      <template v-slot:button>
        <div class="tips-btn-t" v-if="isRetryBtnShown" @click="retry">重试</div>
      </template>
    </Prompt>

    <!-- <Prompt v-if="isActivityEnd" class="end" :is-shown="isActivityEnd" is-close-hidden="true">
      <template v-slot:content>
        <div class="title">活动已结束</div>
        <p class="description">您可以关注“腾讯充值”公众号，后续活动将会通过公众号通知您～</p>
      </template>
    </Prompt> -->

<!--    <Prompt v-if="isInBrowserShown" :is-shown.sync="isInBrowserShown" is-close-hidden="true">-->
<!--      <div slot="content">-->
<!--        <p class="pop3_tit2">请在微信或手Q内打开本次活动</p>-->
<!--      </div>-->
<!--      <div slot="button">-->
<!--        <a href="javascript: void 0;"-->
<!--           class="disbanded popbtn" @click="goWechatOpenlink">微信</a>-->
<!--        <a href="javascript:void 0;" @click="goQQ" class="cancel popbtn">QQ</a>-->
<!--      </div>-->
<!--    </Prompt>-->


    <Prompt v-if="period==peroidEnums.FORMATION && isTeamFull && !isInTeam" :is-shown.sync="period==peroidEnums.FORMATION && isTeamFull" is-close-hidden="true">
      <template v-slot:content>
        <div class="title">温馨提示</div>
        <p class="description" v-if="userAgent.weixin">抱歉，已经满员啦～进入首页试试自己创建吧！</p>
        <p class="description" v-else>抱歉，当前小队已满员，去创建一支新小队吧！</p>
      </template>
      <template v-slot:button>
        <div class="tips-btn-t" @click="returnIndexAndCreateTeam">确定</div>
      </template>
    </Prompt>

    <SubscribePrompt 
      :gameInfo="gameInfo" 
      :is-shown.sync="subscribePromptShow" 
      v-if="subscribePromptShow" 
      @showFollowDialog="showFollowDialog" 
      @setToastMsg="setToastMsg"
      @setLoading="setLoading"
    ></SubscribePrompt>
  </div>

</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex"
import { format } from "date-fns"
import PopDialog from "./components/PopDialog.vue"
import Prompt from "./components/Prompt.vue"
import CountDown from "../common/components/CountDown.vue"
import Toast from "./components/Toast.vue"
import TeamMembers from "./components/TeamMembers.vue"
import FollowDialog from "./components/FollowDialog.vue"
import SubscribePrompt from "./components/SubscribePrompt.vue"
import * as config from "./config"
import * as request from "../common/utils/request"
import { getStrParams } from "../bargain/utils/url"
import { UTC8TimeToTimeStamp } from "../bargain/utils/helper"

export default {
  name: "Team",
  components: {
    PopDialog,
    Prompt,
    CountDown,
    Toast,
    TeamMembers,
    FollowDialog,
    SubscribePrompt
  },
  data() {
    return {
      teamInfo: "",
      isTeamFull: "",
      teamMembers: "",
      selfMember: "", //当前登陆的用户在战队中的列表中信息能否查到
      hasSamePlatform: "", //当前登陆用户和队长是否同平台,wx和QQ不能互相加入
      isInTeam: "", //是否已经在战队中了
      captain: "", //队长信息
      isCaptain: "", //是否队长
      applicantList: [],
      teamTab: config.TAB,
      isTeamNeedApproval: "",
      selectedTeamTab: config.TAB.MY_TEAM,
      isPopDialogShown: false,
      popDialogMsg: "",
      isDismissTeamShown: false,
      quitTeamEndTime: "",
      joinStatus: config.JOINSTATUS,
      toastMsg: "",
      peroidEnums: config.PEROID,
      currentActvity: "",
      isFollowButtonShown: false, //是否展示订阅按钮
      isFollowDialogShown: false,
      period: "", //当前处于哪个期间
      teamConsumption: "",
      totalConsumption: "",
      selfConsumption: 0,
      // now: "", //当前时间
      coupon: "", //团队档位奖品
      individualCoupon: "", //个人档位
      prizeStatusEnums: config.PRIZESTATUS,
      currentApplicantPage: 1,
      applicantFetchFinished: false,
      isApplicationRefreshing: false,
      isQuitDialogShown: false,
      isQueueShown: false,
      isRetryBtnShown: false,
      retryCountDown: 10,
      isActivityEnd: false,
      isInBrowserShown: false,
      consumeAds: "",
      subscribePromptShow: false,
      periodBeforeConversionTime: false
    }
  },
  mounted() {
    this.setOnShareHandler({ page: "detail" })
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  computed: {
    ...mapState(["userAgent", "accountType", "gameInfo", "nickname", "avatar"]),
    ...mapGetters(["loginState", "now", "pf"]),
    currencyName() {
      return this.gameInfo.shop.currency
    }
  },
  methods: {
    ...mapActions([
      "getActivity",
      "getTeamDetail",
      "getLoginState",
      "dismissTeam",
      "joinTeam",
      "setTeamCreatedDialogShown",
      "setShareTeamId",
      "quitTeam",
      "approveMember",
      "setTeamApproval",
      "queryFollow",
      "getTeamConsumption",
      "setOnShareHandler",
      "setJackPot",
      "reportUserAction",
      "getLuckDrawAward",
      "getLuckCoupon",
      "createQQGroup",
      "getTotalParticipant",
      "jumpToMqq",
      "subscribeActivity",
      "setIndividualJackpot",
      "getConsumeAds",
      "setLoading"
    ]),
    init() {
      this.getActivity()
        .then(res => {
          let now = this.now

          if (now > UTC8TimeToTimeStamp(this.gameInfo.conversionTime)) {
            this.periodBeforeConversionTime = false
          }
          if (now < UTC8TimeToTimeStamp(this.gameInfo.conversionTime)) {
            this.periodBeforeConversionTime = true
          }

          let pk = res.filter(rule => rule.period == config.PEROID.PK)[0]
          res.forEach(act => {
            if (now <= UTC8TimeToTimeStamp(act.end_time) && now >= UTC8TimeToTimeStamp(act.begin_time)) {
              this.period = act.period
              this.currentActvity = act
            }
            if (act.period == this.peroidEnums.PK) {
              this.coupon = act.present_item
              this.individualCoupon = act.individual_present_type
            }
          })
          //如果不在组队期和PK期，说明当前处于准备期,活动结束会返回1414

          if (!this.period) {
            this.period = this.peroidEnums.PREPARE
          }
          if (now > UTC8TimeToTimeStamp(pk.end_time)) {
            this.period = this.peroidEnums.END
            this.isActivityEnd = true
          } else {
            return this.getLoginState().then(() => {
              this.getTotalParticipant()
              return this.getJoinedMembers()
            })
          }
        })
        .catch(res => {
          if (res.ret == 1414) {
            this.period = this.peroidEnums.END
            this.isActivityEnd = true
          } else if (res == "无登陆态") {
            return
          } else {
            let msg = `系统繁忙，请稍后再试！${res.ret ? `(${res.ret})` : ""}`
            if (res && res.msg && res.err_code == "") {
              this.isPopDialogShown = true
              msg = res.msg
              this.popDialogMsg = msg
            } else {
              this.queue(res)
            }
          }
        })
    },
    retry() {
      this.isQueueShown = false
      this.init()
    },
    queue(res) {
      this.isQueueShown = true
      this.isRetryBtnShown = false
      this.retryCountDown = 10
      let queueTimer = setInterval(() => {
        this.retryCountDown--
        if (this.retryCountDown == 0) {
          this.isRetryBtnShown = true
          clearInterval(queueTimer)
        }
      }, 1000)
      this.reportUserAction({
        iformat: config.REPORT.PAGEVIEW.TEAM_QUEUE,
        resultInfo: res
      })
    },
    getJoinedMembers() {
      return this.getTeamDetail({
        team_id: this.$route.params.team_id,
        filter_status: config.JOINSTATUS.JOINED
      }).then(res => {
        this.teamInfo = res.info.team_info
        this.isTeamFull = this.teamInfo.join.length == this.teamInfo.max_join_quantity //是否满员
        this.isCaptain = res.info.user_openid === res.info.team_info.origin
        this.selfMember = res.info.team_info.join.filter(m => m.uin == res.info.user_openid)[0]
        this.isInTeam = this.selfMember && this.selfMember.status == config.JOINSTATUS.JOINED
        this.$parent.isInTeam = !!this.isInTeam
        this.captain = res.info.team_info.join.filter(m => m.uin == this.teamInfo.origin)[0]
        this.teamMembers = res.info.team_info.join.filter(m => m.uin != this.teamInfo.origin).sort((a, b) => {
          //队员展示按时间排序
          return b.join_time - a.join_time
        })
        this.isTeamNeedApproval = this.teamInfo.need_approval == "1"

        if (this.isInTeam) {
          this.quitTeamEndTime =
            this.selfMember.join_time +
            (this.userAgent.weixin ? this.gameInfo.weixinQuitTeamCountDown : this.gameInfo.quitTeamCountDown) * 60 * 60
        }

        if (this.period == this.peroidEnums.FORMATION) {
          if (this.isCaptain) {
            //战队队长订阅审批提醒查下用户有无关注公众号
            if (this.isTeamNeedApproval) {
              this.queryFollow().then(followRes => {
                this.isFollowButtonShown = !followRes.info.is_followed
              })
            }
            // 团长才需要查询参团申请
            this.getApplyMembers()
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DETAIL_CAPTION,
              resultInfo: {
                team_id: this.teamInfo.team_id
              }
            })
          } else if (this.isInTeam) {
            this.queryFollow().then(followRes => {
              this.isFollowButtonShown = !followRes.info.is_followed
            })
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DETAIL_TEAM_MEMBER,
              resultInfo: {
                team_id: this.teamInfo.team_id
              }
            })
          } else {
            // !selfMember ||( isInTeam==false && accountType==teamInfo.origin_type)
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DETAIL_NEW_USER,
              resultInfo: {
                team_id: this.teamInfo.team_id
              }
            })
          }
        }

        if (this.period == this.peroidEnums.PREPARE || this.isTeamFull) {
          //战队满员或者在准备期的时候查下用户有无关注公众号
          this.queryFollow().then(followRes => {
            this.isFollowButtonShown = !followRes.info.is_followed
          })
          if (this.teamMembers.length == 0) {
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DETAIL_TEAM_FORM_FAILED,
              resultInfo: {
                team_id: this.teamInfo.team_id
              }
            })
          } else if (this.isCaptain) {
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DETAIL_TEAM_FORM_SUCCCESS_FROM_CAPTAIN,
              resultInfo: {
                team_id: this.teamInfo.team_id
              }
            })
          } else if (!this.isInTeam) {
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DETAIL_USER_NEVER_JOIN,
              resultInfo: {
                team_id: this.teamInfo.team_id
              }
            })
          } else {
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DETAIL_TEAM_FORM_SUCCESS_FROM_MEMBER,
              resultInfo: {
                team_id: this.teamInfo.team_id
              }
            })
          }
        }

        if (this.period == this.peroidEnums.PK && this.teamMembers.length > 0) {
          if (this.isCaptain || this.isInTeam) {
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DETAIL_CONSUME,
              resultInfo: {
                team_id: this.teamInfo.team_id
              }
            })

            this.getTeamConsumptionAndDrawInfo(res.info.user_openid)

            this.getConsumeAds().then(res => {
              this.consumeAds = res
            })

            let now = this.now
            // now = `${now.getHours()}:${now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes()}:${
            //   now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds()
            // }`
            if (now > UTC8TimeToTimeStamp(this.gameInfo.conversionTime)) {
              this.reportUserAction({
                iformat: config.REPORT.PAGEVIEW.ACTIVITY_DOUNTDOWN,
                resultInfo: {
                  team_id: this.teamInfo.team_id
                }
              })
            }
          } else {
            this.setJackPot(this.coupon)
            this.setIndividualJackpot(this.individualCoupon)
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DETAIL_USER_NEVER_JOIN,
              resultInfo: {
                team_id: this.teamInfo.team_id
              }
            })
          }
        } else {
          this.setJackPot(this.coupon)
          this.setIndividualJackpot(this.individualCoupon)
        }
      })
    },
    getTeamConsumptionAndDrawInfo(selfUser) {
      this.getTeamConsumption()
        .then(consumptionRes => {
          let total = 0,
            consumer = [],
            consumptionInfo = consumptionRes.info.amt_info,
            rate = this.gameInfo.shop.currencyRate || 1
          this.selfConsumption = consumptionInfo?.find(m => m.openid == selfUser)?.amt * rate || 0
          this.teamInfo.join.forEach(joiner => {
            let member = consumptionInfo?.find(m => m.openid == joiner.uin)
            if (member) {
              member.amt = member.amt * rate
              total += member.amt
              consumer.push(Object.assign(joiner, member))
            } else {
              consumer.push(Object.assign(joiner, { amt: 0 }))
            }
          })

          this.teamConsumption = consumer.sort((a, b) => {
            return b.amt - a.amt
          })
          this.totalConsumption = total
          let threshold = []
          this.coupon.forEach(column => {
            //判断团队消费是否达到奖池门槛
            if (total >= column.num) {
              column.status = this.prizeStatusEnums.AVAILABLE
            } else {
              column.status = this.prizeStatusEnums.UNAVAILABLE
            }
            column.isCaptain = this.isCaptain
            threshold.push(column)
          })
          this.coupon = threshold

          this.setJackPot(this.coupon)

          let individualThreshold = []
          this.individualCoupon.forEach(item => {
            if (this.selfConsumption >= item.num) {
              item.status = this.prizeStatusEnums.AVAILABLE
            } else {
              item.status = this.prizeStatusEnums.UNAVAILABLE
            }
            individualThreshold.push(item)
          })
          this.individualCoupon = individualThreshold
          this.setIndividualJackpot(this.individualCoupon)
          // this.getLuckDrawAward({})
          // this.getLuckCoupon()
        })
        .catch(res => {
          // 如果消费期查队伍消费报错，设置奖池，让用户可以看奖池内容
          this.setJackPot(this.coupon)
          this.setIndividualJackpot(this.individualCoupon)

          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.GET_TEAM_CONSUME_ERROR,
            resultInfo: res
          })
          this.handleError(res)
        })
    },
    getApplyMembers() {
      if (this.isApplicationRefreshing) return
      this.isApplicationRefreshing = true
      return this.getTeamDetail({
        team_id: this.teamInfo.team_id,
        curpage: this.currentApplicantPage,
        filter_status: config.JOINSTATUS.APPLY
      })
        .then(res => {
          this.currentApplicantPage += 1

          if (res.info.team_info.join.length == 0) {
            this.applicantFetchFinished = true
          }
          if (!this.selfMember) {
            this.selfMember = res.info.team_info.join.filter(m => m.uin == res.info.user_openid)[0]
          }
          let currentApplicant = res.info.team_info.join.sort((a, b) => {
            //成员展示按时间排序
            return b.join_time - a.join_time
          })
          this.applicantList = this.applicantList.concat(currentApplicant)

          if (this.selfMember && this.selfMember.status == this.joinStatus.APPLY) {
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.DEATIL_APPLY_USER,
              resultInfo: {
                team_id: this.teamInfo.team_id
              }
            })
          }
        })
        .catch(res => {
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.GET_TEAM_APPLY_ERROR,
            resultInfo: res
          })
          this.handleError(res)
        })
        .then(() => {
          this.isApplicationRefreshing = false
        })
    },
    changeTeamTab(tab) {
      if (tab == this.teamTab.MY_TEAM) {
        this.reportUserAction({
          iformat: config.REPORT.CLICK.MY_TEAM
        })
      } else {
        this.reportUserAction({
          iformat: config.REPORT.CLICK.CHECK_APPLY_LIST
        })
      }
      this.selectedTeamTab = tab
    },
    showDismissTeamDialog(b) {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.DISMISS
      })
      this.isDismissTeamShown = b
    },
    handleError(res) {
      if (res && res.ret == 1414) {
        //活动结束
        this.period = this.peroidEnums.END
        this.isActivityEnd = true
        this.reportUserAction({
          iformat: config.REPORT.PAGEVIEW.ACTIVITY_EXPIRED
        })
      } else {
        this.isPopDialogShown = true
        let msg = `系统繁忙，请稍后再试！${res.ret ? `(${res.ret})` : ""}`
        if (res && res.msg && res.err_code == "") {
          msg = res.msg
        }

        this.popDialogMsg = msg
      }
    },
    createGroup() {
      this.createQQGroup()
        .then(() => {
          this.popDialogMsg = "您已创建小队QQ群，请在“我创建的群聊”中查看"
          this.isPopDialogShown = true
        })
        .catch(res => {
          this.handleError(res)
        })
      this.reportUserAction({
        iformat: config.REPORT.CLICK.CREATE_QQ_GROUP,
        resultInfo: {
          team_id: this.teamInfo.team_id
        }
      })
    },
    dismiss() {
      this.dismissTeam({ team_id: this.teamInfo.team_id })
        .then(() => {
          //解散成功回到首页
          // this.subscribeActivity("cancel")
          this.$router.replace("/")
        })
        .catch(res => {
          this.handleError(res)
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.DISMISS_TEAM_ERROR,
            resultInfo: res
          })
        })
        .then(() => {
          this.isDismissTeamShown = false
        })
    },
    join() {
      // this.isPopDialogShown = true
      // this.popDialogMsg = "申请已发送～"
      // 自动将页面定位到队伍明细
      this.scrollToTeamInfo()

      this.reportUserAction({
        iformat: config.REPORT.CLICK.ALERT_CAPTAIN_APPROVAL,
        resultInfo: {
          team_id: this.teamInfo.team_id
        }
      })

      if (this.accountType != this.teamInfo.origin_type) {
        this.isPopDialogShown = true
        this.popDialogMsg = "本次活动QQ&微信不互通哦，您可以创建自己的小队或切换QQ/微信后再加入该小队"
        return
      }

      this.joinTeam({ team_id: this.teamInfo.team_id })
        .then(() => {
          this.isPopDialogShown = true
          this.popDialogMsg = "申请已发送～"
          if (!this.isTeamNeedApproval) {
            //如果不需要审批刷新下状态
            // this.subscribeActivity("subscribe")
            this.init()
          }
        })
        .catch(res => {
          this.handleError(res)
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.JOIN_TEAM_ERROR,
            resultInfo: res
          })
        })
    },
    scrollToTeamInfo() {
      // 1、当设置body高度为100%时，即固定值：
      // 在ios下，document.body.srcollTop为上滑的值
      // 在android下，document.body.srcollTop为0
      // 2、当设置body高度为initial或者auto时，即body不设置固定高度：
      // 在ios下，document.body.srcollTop为0
      // 在android下，document.body.srcollTop为上滑的值
      let scrollTop = document.querySelector(".content2")?.offsetTop
      if (scrollTop > 0) {
        document.body.scrollTo(0, scrollTop)
      }
    },
    setQuitDialog(shown) {
      this.isQuitDialogShown = shown
    },
    quit() {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.QUIT_TEAM,
        resultInfo: {
          team_id: this.teamInfo.team_id
        }
      })
      this.quitTeam({ team_id: this.teamInfo.team_id })
        .then(() => {
          this.setToastMsg("退出成功")
          this.init()
          // this.subscribeActivity("cancel")
        })
        .catch(res => {
          this.handleError(res)
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.QUIT_TEAM_ERROR,
            resultInfo: res
          })
        })
      this.isQuitDialogShown = false
    },
    setApprovalStatus() {
      let need_approval
      if (this.isTeamNeedApproval) {
        need_approval = 0
      } else {
        need_approval = 1
      }
      this.reportUserAction({
        iformat: config.REPORT.CLICK.SWITCH_APPROVAL,
        resultInfo: {
          from: this.isTeamNeedApproval,
          to: need_approval
        }
      })
      this.setTeamApproval({
        team_id: this.teamInfo.team_id,
        need_approval
      })
        .then(() => {
          this.setToastMsg("设置成功")
          this.isTeamNeedApproval = !!need_approval
        })
        .catch(res => {
          this.handleError(res)
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.SET_TEAM_APPROVAL_ERROR,
            resultInfo: res
          })
        })
    },
    setToastMsg(msg) {
      this.toastMsg = msg
      setTimeout(() => {
        this.toastMsg = ""
      }, 2000)
    },
    approval(member, action) {
      if (action == "agree") {
        this.reportUserAction({
          iformat: config.REPORT.CLICK.PASS_APPLY,
          resultInfo: {
            team_id: this.teamInfo.team_id
          }
        })
      } else {
        this.reportUserAction({
          iformat: config.REPORT.CLICK.IGNORE_APPLY,
          resultInfo: {
            team_id: this.teamInfo.team_id
          }
        })
      }

      this.approveMember({
        team_id: this.teamInfo.team_id,
        applicant: member.uin,
        applicant_type: member.uin_type,
        applicant_action: action
      })
        .then(() => {
          if (action == "agree") {
            this.setToastMsg("审批通过")
          } else {
            this.setToastMsg("操作成功")
          }

          //将操作过的队员剔除掉
          let index = -1

          this.applicantList.filter((m, i) => {
            if (m.uin == member.uin) {
              index = i
            }
          })
          if (action == "agree") {
            this.teamInfo.join.push(this.applicantList[index])
            this.teamMembers.push(this.applicantList[index])
          }
          if (index > -1) {
            this.applicantList.splice(index, 1)
          }
        })
        .catch(res => {
          this.handleError(res)
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.APPROVAL_ERROR,
            resultInfo: res
          })
        })
    },
    showTeamShare() {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.SHARE_TEAM_FROM_CAPTAIN,
        resultInfo: {
          team_id: this.teamInfo.team_id
        }
      })
      this.setTeamCreatedDialogShown(true)
      this.setShareTeamId(this.teamInfo.team_id)
    },
    showTeamShareFromMember() {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.SHARE_TEAM_FROM_MEMBER,
        resultInfo: {
          team_id: this.teamInfo.team_id
        }
      })
      this.setTeamCreatedDialogShown(true)
      this.setShareTeamId(this.teamInfo.team_id)
    },
    returnIndexAndCreateTeam() {
      this.$router.replace("/")
    },
    showCaptainFollowDialog() {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.SUBSCRIBE,
        resultInfo: {
          team_id: this.teamInfo.team_id
        }
      })
      this.isFollowDialogShown = true
    },
    showSubscribeDialog() {
      this.subscribePromptShow = true
    },
    showFollowDialog() {
      this.isFollowDialogShown = true
    },
    goMall() {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.CONTINUE_CONSUME
      })
      const url = `https://pay.qq.com/h5/shop.shtml?pf=${this.pf || "__mds_activity_pk"}#/order/2/biz/2?serviceZone=1`
      if (this.userAgent.weixin || this.userAgent.QQ) {
        location.href = url
      } else if (this.userAgent.msdk) {
        //获取openlink
        this.$parent.redirect(url)
      } else if (this.loginState?.openid && this.loginState.openkey) {
        location.href = `https://pay.qq.com/h5/shop.shtml?${request.serializeParams({
          pf: this.pf || "__mds_activity_pk",
          openid: this.loginState.openid,
          openkey: this.loginState.openkey,
          sessionid: this.loginState.session_id,
          sessiontype: this.loginState.session_type,
          wxAppid2: this.loginState.wx_appid || "",
          qq_appid: this.loginState.qq_appid || ""
        })}#/order/2/biz/2?serviceZone=1`
      } else {
        this.$parent.redirect(url)
      }
    },
    goPostOffice() {
      const url = `https://pay.qq.com/h5/activity/bargain/wzry-post-office.php?pf=${this.pf || "__mds_activity_pk"}`
      if (this.userAgent.weixin || this.userAgent.QQ) {
        location.href = url
      } else {
        //获取openlink
        this.$parent.redirect(url)
      }
    },
    goBuy() {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.BUY_GAMECOIN,
        resultInfo: {
          team_id: this.teamInfo.team_id
        }
      })
      if (this.userAgent.android && (this.userAgent.QQ || this.userAgent.weixin)) {
        location.href = `https://pay.qq.com/h5/shop.shtml?pf=${this.pf}#/order/2/biz/2?serviceZone=1`
      } else {
        this.isPopDialogShown = true
        this.popDialogMsg = `请前往游戏充值${this.currencyName}`
      }
    },
    goWechatOpenlink() {
      location.href = this.gameInfo.openlink
    },
    goQQ() {
      this.jumpToMqq(location.href)
    },
    formatDate(date, style) {
      return format(date, style)
    },
    redirectOut(url) {
      if (this.userAgent.QQ || this.userAgent.weixin) {
        location.href = url
      }
      // else if (this.userAgent.msdk) {
      //   this.$parent.redirect(url)
      // }
      // else if (this.loginState?.openid && this.loginState.openkey) {
      //   location.href = `${url}&${request.serializeParams({
      //
      //     openid: this.loginState.openid,
      //     openkey: this.loginState.openkey,
      //     sessionid: this.loginState.session_id,
      //     sessiontype: this.loginState.session_type,
      //     wxAppid2: this.loginState.wx_appid || "",
      //     qq_appid: this.loginState.qq_appid || ""
      //   })}`
      // }
      else {
        this.$parent.redirect(url)
      }
    },
    /**
     * 获取团员的头像昵称
     */
    getMember(str) {
      let obj = getStrParams(decodeURIComponent(str), true)
      let nickName = "腾讯用户"
      if (obj?.nick_name) {
        try {
          nickName = decodeURIComponent(obj.nick_name)
        } catch (error) {
          nickName = obj.nick_name
        }
      }
      let avatar = obj.img_url || this.gameInfo.defaultAvatar
      return {
        avatar,
        nickName
      }
    }
  }
}
</script>

<style scoped>
</style>
